// 사람 종류(worker_type) 중 3.3%(프리랜서) 알아보기 — 서버 api/services/worker-type.js 와 같은 규칙.
// 2026-11-03 미남님: 안쪽 이름표 'sales'(옛 마케터 명부)를 'freelancer'(3.3%)로 바꿨다(DB 값도 준비 작업 127 로 바뀜).
//   화면에서 3.3% 를 가르는 곳은 모두 이 함수만 쓴다(글자 'freelancer'·'sales' 를 직접 비교하지 말 것).
export const FREELANCER_WORKER_TYPES = ['freelancer'];

export function isFreelancerWorker(workerType) {
  return FREELANCER_WORKER_TYPES.includes(String(workerType || '').trim().toLowerCase());
}
